import { useCallback } from 'react';
import type { JSX } from 'react';

import { ClientRender } from '@change-corgi/core/react/ssr/render';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { LazyComponent, ScrollableComponent } from 'src/app/shared/components/layout/lazy';

export function LazyContributeSection(): JSX.Element {
	const loadComponent = useCallback(
		async () =>
			(await import(/* webpackChunkName: "cmp/homepage_contribute_section" */ '../ContributeSection'))
				.ContributeSection,
		[],
	);

	return (
		<ClientRender placeholder={<Loader size="m" my={256} mx="auto" />}>
			<ScrollableComponent topOffset={200} immediateForBots>
				<LazyComponent loadComponent={loadComponent} />
			</ScrollableComponent>
		</ClientRender>
	);
}
